export const appConfig = {
    DEV_MODE: false, // flag to fetch mock or real fetch
    api: {
        // endPoint: 'http://188.237.83.124:8818'
        endPoint: 'https://ttoportalapi.ankara.edu.tr'
    },
    projectName: "ErmeTech",
    captchaSiteKey: "6Le_JN8rAAAAAP46tZqQE_QUT6A1gRegg1szTXU5",
    // reactAppBaseUrl: 'http://188.237.83.124:8818/'
    reactAppBaseUrl: 'https://ttoportalapi.ankara.edu.tr/'
};

export default appConfig;